/*
 * Copyright (c) Castle Point Learning Systems Corporation, 2013-2023, all rights reserved.
 * NOTICE: Dissemination of the information and/or materials contained in this file is strictly
 * forbidden unless prior written permission is obtained from Castle Point Learning Systems Corporation.
 * See LICENSE.txt (part of this package) for the full notice.
 */

import React, {useMemo} from 'react';
import {Latex as Katex} from 'semantic-math-editor'
import {Styled as S} from "../../VerticalSolver.styled";

interface LatexProps {
    children: string;
}

export const Latex: React.FC<LatexProps> = React.memo(({children}) => {
    const html = useMemo<string>(() => {
        try {
            return Katex.renderLatex(children);
        } catch (e) {
            return e.message;
        }
    }, [children]);

    return (html && <S.Ltx dangerouslySetInnerHTML={{__html: html}}/>);
});
